import {createSelector} from 'reselect';

import {getPost, getPostRepliesCount} from 'mattermost-redux/selectors/entities/posts';
import type {Post} from 'mattermost-redux/types/posts';
import {isSystemEphemeralMessage} from 'mattermost-redux/utils/post_utils';
import type {GlobalState} from 'types/store';

import {getPostsForRootPost} from './get_posts_for_root_post';
import {selectThreadById} from './select_thread_by_id';

export const getThreadReplyCount = createSelector(
    getPostRepliesCount,
    (state: GlobalState, rootPostId: Post['id']) => selectThreadById(state, rootPostId)?.reply_count || 0,
    getPostsForRootPost,
    (_state: GlobalState, rootPostId: Post['id']) => rootPostId,
    (_state: GlobalState, rootPostId: Post['id']) => getPost(_state, rootPostId)?.reply_count ?? 0,
    (postReplyCount, threadReplyCount, loadedThreadPosts, rootPostId, exectPostReplyCount) => {
        const loadedThreadPostsCount = loadedThreadPosts.filter((post) => {
            return post.id !== rootPostId &&
                !isSystemEphemeralMessage(post) &&
                post.state !== 'DELETED';
        }).length;

        return Math.max(postReplyCount, threadReplyCount, loadedThreadPostsCount, exectPostReplyCount);
    },
);

